import { Grid, Skeleton } from '@mui/material';
import Styled from './CardSkeleton.styled';
import LegSkeleton from './components/LegSkeleton';

export type CardSkeletonProps = {
  isMultiCity: boolean;
  isPaxPage?: boolean;
};

function CardSkeleton({ isMultiCity, isPaxPage = false }: CardSkeletonProps): JSX.Element {
  return (
    <Styled.CardWrapper container display="flex" direction="row" xs={12}>
      <Styled.ContentWrapper className="SkeletonWrapper" container display="flex" direction="row" xs={9}>
        <Grid item container direction="column" justifyContent="center" alignItems="start" rowSpacing={1} xs={2}>
          <Grid item xs={3}>
            <Skeleton variant="circular" width={40} height={40} />
            <Styled.AirlineNameSkeleton variant="rectangular" width={52} height={16} />
          </Grid>
        </Grid>
        <Grid item xs={8} container direction="row" justifyContent="center" alignItems="center">
          <LegSkeleton />
        </Grid>
        <Grid item container direction="column" justifyContent="center" alignItems="center" rowSpacing={1} xs={2}>
          <Grid item xs={3}>
            <Skeleton variant="circular" width={40} height={40} />
          </Grid>
        </Grid>
        {isMultiCity && (
          <>
            <Grid item container direction="column" justifyContent="center" alignItems="start" rowSpacing={1} xs={2}>
              <Grid item xs={3}>
                <Skeleton variant="circular" width={40} height={40} />
                <Styled.AirlineNameSkeleton variant="rectangular" width={52} height={16} />
              </Grid>
            </Grid>
            <Grid item xs={8} container direction="row" justifyContent="center" alignItems="center">
              <LegSkeleton />
            </Grid>
            <Grid item container direction="column" justifyContent="center" alignItems="center" rowSpacing={1} xs={2}>
              <Grid item xs={3}>
                <Skeleton variant="circular" width={40} height={40} />
              </Grid>
            </Grid>
          </>
        )}
      </Styled.ContentWrapper>
      <Styled.PriceSkeletonWrapper
        item
        container
        xs={3}
        display="flex"
        direction="column"
        gap={2}
        justifyContent="center"
        alignItems="center"
      >
        {!isPaxPage && <Styled.Skeleton variant="rectangular" width={113} height={20} />}
        <Styled.RoundedRectSkeleton variant="rectangular" width={180} height={40} />
        {!isPaxPage && <Styled.Skeleton variant="rectangular" width={113} height={20} />}
      </Styled.PriceSkeletonWrapper>
    </Styled.CardWrapper>
  );
}

export default CardSkeleton;
